"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreConfig = void 0;
const __1 = require("..");
const getCoreConfig = () => ({
    allowedOrigins: '*',
    env: (0, __1.getEnv)('ENV', 'development'),
    port: (0, __1.getEnv)('PORT', '8080'),
    backendApiKey: (0, __1.getEnv)('BACKEND_API_KEY', '5wTCT2AVuCazmYwPGAjyGVr2pe9kNScunAwCYFeb'),
    dataApiKey: (0, __1.getEnv)('DATA_API_KEY', '5wTCT2AVuCazmYwPGAjyGVr2pe9kNScunAwCYFeb'),
    googleAPI: {
        clientOptions: {
            projectId: 'sapphire-312006',
            keyFilename: (0, __1.getEnv)('GOOGLE_KEY_PATH', '~/workspace/key.json'),
            location: 'US',
        },
    },
    cache: {
        coingeckoOracleCache: { stdTTL: 300, checkperiod: 60 },
        scoreServiceCaching: { stdTTL: 600, checkperiod: 30 },
        passportServiceCaching: { stdTTL: 600, checkperiod: 30 },
    },
    scoreBucketNames: {
        prodnets: 'arcx-prodnets-data',
        testnets: 'arcx-testnets-data',
    },
    screenshotBucketName: 'scores-screenshots',
    chains: {
        1: {
            isTestNetwork: false,
            network: 'homestead',
        },
        4: {
            isTestNetwork: true,
            network: 'rinkeby',
        },
        137: {
            isTestNetwork: false,
            network: 'polygon',
        },
        80001: {
            isTestNetwork: true,
            network: 'mumbai',
        },
    },
    alchemyAPI: {
        rinkeby: (0, __1.getEnv)('ALCHEMY_API_KEY_RINKEBY', '6njuqh1Ld-m476eO6voNl8CLE7n4ZSlN'),
        homestead: (0, __1.getEnv)('ALCHEMY_API_KEY_HOMESTEAD', '6njuqh1Ld-m476eO6voNl8CLE7n4ZSlN'),
        mumbai: (0, __1.getEnv)('ALCHEMY_API_KEY_MUMBAI', 'vguOCzG8QRyrOTWcQyhgumeeYgwZDQKa'),
        polygon: (0, __1.getEnv)('ALCHEMY_API_KEY_POLYGON', 'vguOCzG8QRyrOTWcQyhgumeeYgwZDQKa'),
    },
    defaultChainId: (0, __1.extendedCast)((0, __1.getEnv)('DEFAULT_CHAIN_ID', '4'), __1.asCoreChainId),
    defaultBorrowChainId: (0, __1.extendedCast)((0, __1.getEnv)('DEFAULT_BORROW_CHAIN_ID', '80001'), __1.asBorrowChainId),
});
exports.getCoreConfig = getCoreConfig;
//# sourceMappingURL=config.shared.js.map